import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debug from 'debug';
import { Trivia as TriviaContainer } from './Trivia';
import * as triviaActions from '../actions';
import * as triviaSelectors from '../selectors';
import { playbackSessionActions } from '../constants/playbackSessionActions';

const logger = debug('web:trivia:TriviaLoaderContainer');

const actionRegularExpression = /^WAM_TRIVIA_(\w+):?(.*)/i;

class TriviaLoaderContainer extends Component {
  static propTypes = {
    currentSessionClip: PropTypes.shape(),
    setup: PropTypes.func.isRequired,
    load: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    loadLeaderboard: PropTypes.func.isRequired,
  };

  static defaultProps = {
    currentSessionClip: null,
  };

  componentDidMount() {
    this.props.setup();
  }

  shouldComponentUpdate(nextProps) {
    const { currentSessionClip: { name: prevName } = {} } = this.props;
    const { currentSessionClip: { name: nextName } = {} } = nextProps;
    return prevName !== nextName;
  }

  componentDidUpdate() {
    this.checkCurrentSessionClip();
  }

  checkCurrentSessionClip() {
    const { currentSessionClip, load, clear, loadLeaderboard } = this.props;

    const { endTime, name, startTime } = currentSessionClip || {};
    const clipDuration = Date.parse(endTime) - Date.parse(startTime);
    const [, action, argument] = actionRegularExpression.exec(name) || [];

    logger('Current clip name', name);
    logger('Parsed data', { action, argument });

    clear();

    switch (action) {
      case playbackSessionActions.START:
        break;
      case playbackSessionActions.QUESTION_START:
        load(argument, { answerTimeout: clipDuration });
        break;
      case playbackSessionActions.QUESTION_SCORE:
        loadLeaderboard();
        break;
      case playbackSessionActions.END:
        loadLeaderboard();
        break;
      default:
        logger('Unhandled action: ', action);
        break;
    }
  }

  render() {
    return <TriviaContainer />;
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentSessionClip: triviaSelectors.currentSessionClip(state, ownProps),
});
const mapDispatchToProps = {
  setup: triviaActions.setup,
  load: triviaActions.load,
  reveal: triviaActions.reveal,
  clear: triviaActions.clear,
  loadLeaderboard: triviaActions.loadLeaderboard,
};

export const Trivia = connect(mapStateToProps, mapDispatchToProps)(TriviaLoaderContainer);
